import { render, staticRenderFns } from "./BusinessCaseSb.vue?vue&type=template&id=0fd4e02c&scoped=true"
import script from "./BusinessCaseSb.vue?vue&type=script&lang=js"
export * from "./BusinessCaseSb.vue?vue&type=script&lang=js"
import style0 from "./BusinessCaseSb.vue?vue&type=style&index=0&id=0fd4e02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd4e02c",
  null
  
)

export default component.exports